(function() {
  if (window.__hoverActionsInit) return;
  window.__hoverActionsInit = true;

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-hover-action]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var action = btn.getAttribute('data-hover-action');
    var productCard = btn.closest('product-card');

    if (action === 'quickview') {
      var link = productCard && productCard.querySelector('.product-card__link');
      if (link && link.href) {
        openQuickViewModal(link.href);
      }
    }

    if (action === 'add-to-cart') {
      var qa = productCard && productCard.querySelector('quick-add-component');
      if (qa) {
        var qType = qa.getAttribute('data-quick-add-button');
        if (qType === 'add') {
          var sub = qa.querySelector('button[type="submit"]');
          if (sub) sub.click();
        } else if (typeof qa.handleClick === 'function') {
          qa.handleClick(new MouseEvent('click', { bubbles: true, cancelable: true }));
        }
      }
    }

    if (action === 'wishlist') {
      var pid = btn.getAttribute('data-product-id');
      if (!pid) return;
      var wl = [];
      try { wl = JSON.parse(localStorage.getItem('wishlist') || '[]'); } catch(ex) {}
      var idx = wl.indexOf(pid);
      if (idx > -1) {
        wl.splice(idx, 1);
      } else {
        wl.push(pid);
      }
      try { localStorage.setItem('wishlist', JSON.stringify(wl)); } catch(ex) {}
      document.querySelectorAll('.hover-action-btn--wishlist[data-product-id="' + pid + '"]').forEach(function(b) {
        b.classList.toggle('is-wishlisted', wl.indexOf(pid) > -1);
      });
    }
  });

  function openQuickViewModal(url) {
    var modal = document.getElementById('quickview-fetch-modal');
    if (!modal) {
      modal = document.createElement('dialog');
      modal.id = 'quickview-fetch-modal';
      modal.className = 'quickview-modal';
      modal.innerHTML =
        '<button class="quickview-modal__close" type="button" aria-label="Close">' +
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" width="24" height="24">' +
            '<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6 6 18M6 6l12 12"/>' +
          '</svg>' +
        '</button>' +
        '<div class="quickview-modal__loading"><div class="quickview-modal__spinner"></div></div>' +
        '<div class="quickview-modal__body"></div>';
      document.body.appendChild(modal);

      modal.querySelector('.quickview-modal__close').addEventListener('click', function() {
        modal.close();
      });
      modal.addEventListener('click', function(ev) {
        if (ev.target === modal) modal.close();
      });
      modal.addEventListener('close', function() {
        modal.querySelector('.quickview-modal__body').innerHTML = '';
      });
    }

    var body = modal.querySelector('.quickview-modal__body');
    var loading = modal.querySelector('.quickview-modal__loading');

    body.innerHTML = '';
    loading.style.display = 'flex';
    modal.showModal();

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var mediaScope = doc.querySelector('.product-information__media')
          || doc.querySelector('product-information')
          || doc.querySelector('.product-information')
          || doc.querySelector('main');
        var infoScope = doc.querySelector('product-information')
          || doc.querySelector('.product-information')
          || doc.querySelector('main')
          || doc;

        var images = mediaScope
          ? mediaScope.querySelectorAll('.product-media__image, .product-media img')
          : [];
        var titleEl = infoScope.querySelector('h1')
          || infoScope.querySelector('.product-title')
          || infoScope.querySelector('[class*="title"] h1');
        var descEl = infoScope.querySelector('.product-description')
          || infoScope.querySelector('[class*="product-description"]')
          || infoScope.querySelector('.rte');
        var priceEl = infoScope.querySelector('product-price')
          || infoScope.querySelector('[class*="price"]');

        var title = titleEl ? titleEl.textContent.trim() : '';
        var desc = descEl ? descEl.innerHTML : '';
        var price = priceEl ? priceEl.outerHTML : '';

        if (images.length || title) {
          var slides = [];
          var seen = {};
          images.forEach(function(img) {
            var src = img.getAttribute('src') || '';
            if (!src || seen[src]) return;
            seen[src] = true;
            slides.push({ src: src, alt: img.alt || title });
          });

          var slidesHtml = '';
          var dotsHtml = '';
          slides.forEach(function(s, i) {
            slidesHtml += '<div class="qv-slide' + (i === 0 ? ' qv-slide--active' : '') + '"><img src="' + s.src + '" alt="' + s.alt + '" loading="lazy"></div>';
            dotsHtml += '<button type="button" class="qv-dot' + (i === 0 ? ' qv-dot--active' : '') + '" data-index="' + i + '"></button>';
          });

          body.innerHTML =
            '<div class="qv-layout">' +
              '<div class="qv-images">' +
                '<div class="qv-carousel">' + slidesHtml + '</div>' +
                (slides.length > 1 ?
                  '<button type="button" class="qv-arrow qv-arrow--prev" data-dir="prev"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M15 18l-6-6 6-6"/></svg></button>' +
                  '<button type="button" class="qv-arrow qv-arrow--next" data-dir="next"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 18l6-6-6-6"/></svg></button>' +
                  '<div class="qv-dots">' + dotsHtml + '</div>'
                : '') +
              '</div>' +
              '<div class="qv-info">' +
                '<h2 class="qv-title">' + title + '</h2>' +
                (price ? '<div class="qv-price">' + price + '</div>' : '') +
                '<div class="qv-description">' + desc + '</div>' +
                '<a href="' + url + '" class="qv-cta">\u05e7\u05e0\u05d4 \u05e2\u05db\u05e9\u05d9\u05d5</a>' +
              '</div>' +
            '</div>';

          if (slides.length > 1) {
            var cur = 0;
            var total = slides.length;
            var imagesEl = body.querySelector('.qv-images');
            function goTo(idx) {
              cur = (idx + total) % total;
              imagesEl.querySelectorAll('.qv-slide').forEach(function(s, i) {
                s.classList.toggle('qv-slide--active', i === cur);
              });
              imagesEl.querySelectorAll('.qv-dot').forEach(function(d, i) {
                d.classList.toggle('qv-dot--active', i === cur);
              });
            }
            imagesEl.querySelector('.qv-arrow--prev').addEventListener('click', function() { goTo(cur + 1); });
            imagesEl.querySelector('.qv-arrow--next').addEventListener('click', function() { goTo(cur - 1); });
            imagesEl.querySelectorAll('.qv-dot').forEach(function(d) {
              d.addEventListener('click', function() { goTo(parseInt(d.dataset.index)); });
            });

            (function() {
              var startX = 0, startY = 0, dragging = false, moved = false;
              var threshold = 40;

              function onStart(x, y) {
                startX = x;
                startY = y;
                dragging = true;
                moved = false;
              }
              function onMove(x, y) {
                if (!dragging) return;
                if (Math.abs(x - startX) > 10) moved = true;
              }
              function onEnd(x) {
                if (!dragging) return;
                dragging = false;
                var diff = x - startX;
                if (Math.abs(diff) >= threshold) {
                  if (diff > 0) {
                    goTo(cur + 1);
                  } else {
                    goTo(cur - 1);
                  }
                }
              }

              imagesEl.addEventListener('touchstart', function(e) {
                var t = e.touches[0];
                onStart(t.clientX, t.clientY);
              }, { passive: true });
              imagesEl.addEventListener('touchmove', function(e) {
                var t = e.touches[0];
                onMove(t.clientX, t.clientY);
                if (moved) e.preventDefault();
              }, { passive: false });
              imagesEl.addEventListener('touchend', function(e) {
                var t = e.changedTouches[0];
                onEnd(t.clientX);
              });

              imagesEl.addEventListener('mousedown', function(e) {
                onStart(e.clientX, e.clientY);
                e.preventDefault();
              });
              imagesEl.addEventListener('mousemove', function(e) {
                onMove(e.clientX, e.clientY);
              });
              imagesEl.addEventListener('mouseup', function(e) {
                onEnd(e.clientX);
              });
              imagesEl.addEventListener('mouseleave', function(e) {
                if (dragging) onEnd(e.clientX);
              });
            })();
          }
        } else {
          body.innerHTML = '<p style="padding:2rem;text-align:center;">Could not load product details.</p>';
        }
        loading.style.display = 'none';
      })
      .catch(function() {
        body.innerHTML = '<p style="padding:2rem;text-align:center;">Could not load product details.</p>';
        loading.style.display = 'none';
      });
  }

  function restoreWishlist() {
    var wl = [];
    try { wl = JSON.parse(localStorage.getItem('wishlist') || '[]'); } catch(ex) {}
    wl.forEach(function(id) {
      document.querySelectorAll('.hover-action-btn--wishlist[data-product-id="' + id + '"]').forEach(function(b) {
        b.classList.add('is-wishlisted');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreWishlist);
  } else {
    restoreWishlist();
  }

  function findSlideshow(gallery) {
    if (!gallery) return null;
    return gallery.querySelector('slideshow-component');
  }

  function findMainImage(card) {
    return card.querySelector('.card-gallery slideshow-slide[aria-hidden="false"] img.product-media__image')
      || card.querySelector('.card-gallery .product-media__image')
      || card.querySelector('.card-gallery img:not(.thumbnail-item img)');
  }

  function swapImageFallback(gallery, newSrc, persist) {
    if (!gallery || !newSrc) return;
    var mainImg = findMainImage(gallery.closest('product-card') || gallery.closest('.product-card__content') || gallery);
    if (!mainImg) return;
    if (!gallery._originalSrc) {
      gallery._originalSrc = mainImg.src;
      gallery._originalSrcset = mainImg.srcset || '';
    }
    mainImg.srcset = '';
    mainImg.src = newSrc;
    if (persist) {
      gallery._originalSrc = newSrc;
      gallery._originalSrcset = '';
    }
  }

  function selectThumb(thumb, options) {
    options = options || {};
    var gallery = thumb.closest('.card-gallery');
    if (!gallery) return false;

    var slideshow = findSlideshow(gallery);
    var slideId = thumb.getAttribute('data-slide-id');

    if (slideshow && slideId && typeof slideshow.select === 'function') {
      try {
        slideshow.select({ id: slideId }, undefined, { animate: options.animate !== false });
        if (options.persist) {
          gallery._activeSlideId = slideId;
        }
        return true;
      } catch (ex) {}
    }

    swapImageFallback(gallery, thumb.getAttribute('data-large-src'), !!options.persist);
    return true;
  }

  function markActive(thumb) {
    var thumbs = thumb.closest('.custom-card-thumbnails');
    if (!thumbs) return;
    thumbs.querySelectorAll('.thumbnail-item').forEach(function(t) {
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
  }

  document.addEventListener('mouseover', function(e) {
    if (!(e.target instanceof Element)) return;
    var thumb = e.target.closest('.thumbnail-item');
    if (!thumb) return;
    var gallery = thumb.closest('.card-gallery');
    if (gallery && gallery._activeThumb === thumb) return;
    if (gallery) gallery._activeThumb = thumb;
    selectThumb(thumb, { animate: false });
    markActive(thumb);
  });

  document.addEventListener('click', function(e) {
    if (!(e.target instanceof Element)) return;
    var thumb = e.target.closest('.thumbnail-item');
    if (!thumb) return;
    e.preventDefault();
    e.stopPropagation();
    selectThumb(thumb, { animate: true, persist: true });
    markActive(thumb);
    var gallery = thumb.closest('.card-gallery');
    if (gallery) {
      gallery._clicked = true;
      gallery._activeThumb = thumb;
    }
  });

  document.addEventListener('mouseout', function(e) {
    if (!(e.target instanceof Element)) return;
    var thumbs = e.target.closest('.custom-card-thumbnails');
    if (!thumbs) return;
    if (e.relatedTarget && thumbs.contains(e.relatedTarget)) return;

    var gallery = thumbs.closest('.card-gallery');
    if (!gallery) return;

    if (gallery._clicked) {
      gallery._clicked = false;
      gallery._activeThumb = null;
      return;
    }

    gallery._activeThumb = null;

    var slideshow = findSlideshow(gallery);
    if (slideshow && typeof slideshow.select === 'function') {
      var targetId = gallery._activeSlideId;
      try {
        if (targetId) {
          slideshow.select({ id: targetId }, undefined, { animate: false });
        } else {
          slideshow.select(0, undefined, { animate: false });
        }
      } catch (ex) {}

      thumbs.querySelectorAll('.thumbnail-item').forEach(function(t) {
        t.classList.toggle('is-active', t.getAttribute('data-slide-id') === targetId);
      });
      return;
    }

    if (gallery._originalSrc) {
      var mainImg = findMainImage(gallery.closest('product-card') || gallery.closest('.product-card__content') || gallery);
      if (mainImg) {
        mainImg.src = gallery._originalSrc;
        mainImg.srcset = gallery._originalSrcset;
      }
      gallery._originalSrc = null;
      gallery._originalSrcset = null;
    }

    thumbs.querySelectorAll('.thumbnail-item').forEach(function(t) {
      t.classList.remove('is-active');
    });
  });

  if (!document.querySelector('media-gallery')) {
    document.addEventListener('variant:update', function(e) {
      var source = e.detail && e.detail.data && e.detail.data.html;
      if (!source) return;
      var currentMedia = document.querySelector('.product-information__media');
      if (!currentMedia) return;
      var newMedia = source.querySelector('.product-information__media');
      if (newMedia) {
        currentMedia.innerHTML = newMedia.innerHTML;
      }
    }, true);
  }
})();

(function() {
  if (window.__productPageThumbsInit) return;
  window.__productPageThumbsInit = true;

  function buildProductPageThumbs() {
    var mediaWrapper = document.querySelector('.product-information__media');
    if (!mediaWrapper) return false;
    if (mediaWrapper.querySelector('.product-page-thumbs')) return true;

    var gallery = mediaWrapper.querySelector('.card-gallery');
    if (!gallery) return false;

    var images = gallery.querySelectorAll('.product-media__image, slideshow-slide img');
    if (images.length < 2) {
      var slides = gallery.querySelectorAll('slideshow-slide');
      if (slides.length >= 2) {
        images = [];
        slides.forEach(function(s) {
          var img = s.querySelector('img');
          if (img) images.push(img);
        });
      }
    }
    if (!images || images.length < 2) return false;

    var container = document.createElement('div');
    container.className = 'product-page-thumbs';
    var seen = {};

    var imgArray = Array.prototype.slice.call(images);
    imgArray.forEach(function(img, i) {
      var src = img.src || img.getAttribute('src') || '';
      if (!src || seen[src]) return;
      seen[src] = true;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'product-page-thumb' + (Object.keys(seen).length === 1 ? ' product-page-thumb--active' : '');
      btn.dataset.slideIndex = i;
      var slide = img.closest('slideshow-slide');
      btn.dataset.slideId = slide ? (slide.getAttribute('slide-id') || '') : '';
      var thumbImg = document.createElement('img');
      thumbImg.src = src;
      thumbImg.alt = img.alt || '';
      thumbImg.loading = 'lazy';
      btn.appendChild(thumbImg);
      container.appendChild(btn);
    });

    if (container.children.length >= 2) {
      mediaWrapper.appendChild(container);
      return true;
    }
    return false;
  }

  function tryBuild(attempts) {
    if (buildProductPageThumbs()) return;
    if (attempts > 0) {
      setTimeout(function() { tryBuild(attempts - 1); }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { tryBuild(6); });
  } else {
    tryBuild(6);
  }

  document.addEventListener('click', function(e) {
    var thumb = e.target.closest('.product-page-thumb');
    if (!thumb) return;
    e.preventDefault();
    e.stopPropagation();

    var index = parseInt(thumb.dataset.slideIndex, 10);
    var wrapper = thumb.closest('.product-information__media');
    if (!wrapper) return;

    var slideshow = wrapper.querySelector('slideshow-component');
    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(index, null, { animate: true });
    } else {
      var slides = wrapper.querySelectorAll('slideshow-slide');
      slides.forEach(function(s) { s.setAttribute('aria-hidden', 'true'); });
      if (slides[index]) slides[index].setAttribute('aria-hidden', 'false');
    }

    wrapper.querySelectorAll('.product-page-thumb').forEach(function(t) {
      t.classList.remove('product-page-thumb--active');
    });
    thumb.classList.add('product-page-thumb--active');
  });
})();
